<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>CEO Turnover Reasons</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateCeoTurnoverReason()">
        <mat-icon>add</mat-icon>
        Add CEO Turnover Reason
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="ceoTurnoverReasons()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditCeoTurnoverReason($event)"
      (deleteClick)="onDeleteCeoTurnoverReason($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
